// extracted by mini-css-extract-plugin
module.exports = {"bannerNotification":"_83cbf92","top":"_8602bdb","bottom":"_a3ca2b2"};